import { configure } from '@paytrie/client'

import { authService } from '@/services/auth'
import { getApiBaseUrl } from '@/utils/api'

export const configurePaytrieClient = (): boolean => {
  const authHeader = authService.getAuthHeader()
  configure({
    baseUrl: getApiBaseUrl(),
    ...(authHeader && { headers: { Authorization: authHeader } }),
  })
  return !!authHeader
}
